import { Icon } from '@bb/elements-web';
import React from 'react';
import styled from 'styled-components';

function HomeIcon() {
  return (
    <IconCircle>
      <Icon icon="homeFilled" color="primary" size={20} />
    </IconCircle>
  );
}

export default HomeIcon;

const IconCircle = styled.div`
  border-radius: 50%;
  width: 40px;
  height: 40px;
  background-color: #f0f7ff;
  display: flex;
  align-items: center;
  justify-content: center;
`;
